import {
    battery,
    batteryDead,
    calibrationMinMax,
    lastCalibration,
    lastData,
    lastSeen,
    motorSpeed,
    pidAlgoPeriod,
    voltageDrop,
} from '~/helpers/fields-description';
import { Const } from '../../../constants/Const.constant';
import { NAModule } from '../NAModule.model';

export class NVE extends NAModule {
    hasOperationDissociate = false;

    battery_levels = {
        high: Const.NABatteryLevelNVEModule.NVE_BATTERY_LEVEL_0,
        medium: Const.NABatteryLevelNVEModule.NVE_BATTERY_LEVEL_1,
        low: Const.NABatteryLevelNVEModule.NVE_BATTERY_LEVEL_2,
    };

    radio_id?: string;
    valve_calibration?: {
        min_position: string;
        max_position: string;
        calibration_error: number;
        time: number;
    };
    motor_frequency?: number;
    motor_voltage_drop?: number;
    battery_dead?: boolean;
    pid_algo_period?: number;

    isWired = false;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldLastSeen() {
        return lastSeen(
            this.last_seen,
            this.outdatedLastSeen ? 'error--text' : '',
        );
    }
    get fieldLastData() {
        return lastData(
            this.last_data,
            this.outdatedLastData ? 'error--text' : '',
        );
    }
    get fieldMotorSpeed() {
        if (typeof this.motor_frequency !== 'undefined') {
            return motorSpeed(this.motor_frequency);
        }
    }
    get fieldVoltageDrop() {
        if (typeof this.motor_voltage_drop !== 'undefined') {
            return voltageDrop(this.motor_voltage_drop);
        }
    }
    get fieldBatteryDead() {
        if (typeof this.battery_dead !== 'undefined') {
            return batteryDead(this.battery_dead);
        }
    }
    get fieldPidAlgoPeriod() {
        if (typeof this.pid_algo_period !== 'undefined') {
            return pidAlgoPeriod(this.pid_algo_period);
        }
    }
    get fieldLastCalibration() {
        if (this.valve_calibration) {
            return lastCalibration(this.valve_calibration?.time);
        }
    }

    get fieldCalibrationMinMax() {
        if (this.valve_calibration) {
            let value = '';

            if (
                typeof this.valve_calibration.min_position !== 'undefined' &&
                typeof this.valve_calibration.max_position !== 'undefined'
            ) {
                value +=
                    this.valve_calibration.min_position +
                    '/' +
                    this.valve_calibration.max_position;
            }

            if (Number(this.valve_calibration.calibration_error) !== 0) {
                const error =
                    'Error ' +
                    this.calibrationErrors[
                        this.valve_calibration.calibration_error
                    ] +
                    '';
                value += value === '' ? error : ' (' + error + ')';
            }
            return calibrationMinMax(value);
        }
    }
    calibrationErrors = [
        'OK',
        'Motor base not reached',
        'Valve disconnected',
        'Critical battery',
        'Low battery',
        'Bad calibration',
        'Far calibration',
        'No min detected',
        'Valve obstructed',
        'Motor Cap',
        'Not calibrated yet',
    ];
}
